import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import Button from "@mui/material/Button";
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
/*import ListItem from '@mui/material/ListItem';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';*/
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { Link } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CustomSelect from "../CustomComponents/CustomSelect";
import { PropListItem } from "../CustomComponents/PropListItem";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import {logger,checkAuthentication} from '../../utils';

export default function EditTaskGroupDialog({ handleEditCallback, data }) {
  //  logger({EditData: data})
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [isDisabled, setIsDisabled] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(true); 
    const timerRef = React.useRef(null);
    const [taskVariableChoices, setTaskVariableChoices] = React.useState([]);

    const [PropList, setpropList] = React.useState([])

    const initialValues = {
        Name: data.Name,
        IsActive: data.IsActive ? true : false,
        propList: PropList
    };

    const validFormSchema = Yup.object({
        Name: Yup
            .string('Enter a name for this Group Name')
            .required('Name is required'),
        IsActive: Yup
            .boolean(),
        propList: Yup.array().of(
            Yup.object().shape({
                TaskVariable: Yup.string().required("Task Variable is requried"),
            })
        )

    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            GroupID: data.GroupID,
            Name: values.Name,
            IsActive: values.IsActive ? 1 : 0,
            PropList: values.propList
        };

        handleEditCallback(msg);

        handleClose();
    })

    const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
       // setRefresh(true);
    };

    const setTaskVariable = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setTaskVariableChoices(choices)
    }

    const setProps = (json) => {
        
        let props = [];
        json.forEach(prop => props.push({ num: props.length, TaskVariable: prop.TaskVariableID, ID: prop.ID, IsDelete: false }))
        setpropList(props)
        
    }
    const wait = () => {
        logger('initvalues in wait---', initialValues.propList)
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            if (!initialValues.propList.length) {
                logger(`reset refresh in wait`)
                setRefresh(true)

            }
        }, 4500);
    }
    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {

            fetch('api/task_variable', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setTaskVariable(json));

            fetch(`api/task_group/${data.GroupID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setProps(json));

            if (initialValues.propList.length) {
                //logger(`in week length`)
                //  wait()
                setIsLoading(false)
                setRefresh(false)
            }
        }
    })

    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit Group" placement="top-end">
                <IconButton
                    variant="contained"
                    onClick={handleClickOpen}
                >
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">

                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        enableReinitialize
                       // validateOnChange={false} 
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (

                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Task Group
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Task Group Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name='Name'
                                            id="outlined-taskProp"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="Name"
                                        />
                                    </FormControl>
                                </div>
                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsActive"
                                        label="Active"
                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                    />
                                </FormControl>
                                {(isLoading) &&
                                    <Box>
                                    <FormControl sx={{ m: 1, height: 200, width: 300 }}>
                                        {logger('in display wait')}
                                        <Box sx={{
                                            display: 'flex',
                                            minHeight: 200,
                                            width: '100%',
                                            m: 1,
                                            alignContent: 'center'
                                        }}>
                                            <Fade
                                                in={(isLoading)}
                                                style={{
                                                    transitionDelay: !isLoading ? '800ms' : '0ms',
                                                }}
                                                unmountOnExit
                                            >
                                                <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                                    <CircularProgress color="secondary" />
                                                    <CircularProgress color="success" />
                                                    <CircularProgress color="inherit" />
                                                </Stack>
                                            </Fade>
                                        </Box>
                                        {wait()}
                                        </FormControl> </Box>
                                }
                                { (!isLoading) &&
                                    <FieldArray name="propList">
                                        {({ push, remove }) => (
                                            <Grid container justifyContent="flex-start"
                                                sx={{ display: 'flex', }} >
                                                {logger('in output grid', props.values.propList) }
                                                <Grid item xs={12}>
                                                    <Grid container spacing={2} sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        flexWrap: 'wrap',
                                                        maxHeight: '400px'

                                                    }} >
                                                        {props.values.propList.map((p, index) => {
                                                            const TaskVariable = `propList[${index}].TaskVariable`;
                                                            const touchedtaskVariable = getIn(props.touched, TaskVariable);
                                                            const errortaskVariable = getIn(props.errors, TaskVariable);

                                                            const IsDelete = `propList[${index}].IsDelete`;
                                                            const touchedIsDelete = getIn(props.touched, IsDelete);
                                                            const errorIsDelete = getIn(props.errors, IsDelete);
                                                            const showDelete = false;

                                                            return (
                                                                <Grid key={p.num} item xs={3}>
                                                                    {p.ID > 0 ?
                                                                        <FormControl sx={{ m: 1, width: '240px' }}>
                                                                            <InputLabel>Task Variable</InputLabel>
                                                                            <CustomSelect
                                                                                disabled
                                                                                name={TaskVariable}
                                                                                id="outlined-taskVariable-{index}"
                                                                                labelId="outlined-taskVariable"
                                                                                label="Task Variable"
                                                                                options={taskVariableChoices}
                                                                                onChange={props.handleChange}
                                                                                onBlur={props.handleBlur}
                                                                                value={p.TaskVariable}
                                                                                error={touchedtaskVariable && Boolean(errortaskVariable)}
                                                                                helperText={touchedtaskVariable && props.errors.errortaskVariable}
                                                                            />
                                                                        </FormControl>
                                                                        :
                                                                        <Grid container sx={{
                                                                            display: 'flex',
                                                                            flexDirection: 'row',
                                                                            alignItems: 'flex-start'
                                                                        }} >
                                                                            <Grid item>
                                                                                <FormControl sx={{ m: 1, width: '200px' }}>
                                                                                    <InputLabel>Task Variable</InputLabel>
                                                                                    <CustomSelect
                                                                                        name={TaskVariable}
                                                                                        id="outlined-taskVariable-{index}"
                                                                                        labelId="outlined-taskVariable"
                                                                                        label="Task Variable"
                                                                                        options={taskVariableChoices}
                                                                                        onChange={props.handleChange}
                                                                                        onBlur={props.handleBlur}
                                                                                        value={p.TaskVariable}
                                                                                        error={touchedtaskVariable && Boolean(errortaskVariable)}
                                                                                        helperText={touchedtaskVariable && props.errors.errortaskVariable}
                                                                                    />
                                                                                </FormControl>
                                                                            </Grid><Grid item>
                                                                                <IconButton color="secondary" sx={{ p: '10px' }} aria-label="Cancel"
                                                                                    onClick={() => remove(index)}>

                                                                                    <CancelIcon />
                                                                                </IconButton>
                                                                            </Grid></Grid>
                                                                    }
                                                                    {p.ID && showDelete ?
                                                                        <FormControlLabel
                                                                            label="Delete"
                                                                            control={<Checkbox checked={p.IsDelete} />}
                                                                            name={IsDelete}
                                                                            onChange={props.handleChange}
                                                                            helperText={
                                                                                touchedIsDelete && errorIsDelete
                                                                                    ? errorIsDelete
                                                                                    : ""
                                                                            }
                                                                            error={Boolean(touchedIsDelete && errorIsDelete)}
                                                                        />
                                                                        :
                                                                        showDelete && <Button
                                                                            margin="normal"
                                                                            type="button"
                                                                            color="secondary"
                                                                            variant="outlined"
                                                                            onClick={() => remove(index)}>
                                                                            x
                                                                        </Button>}

                                                                </Grid>
                                                            );
                                                        })}
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        type="button"
                                                        variant="outlined"
                                                        sx={{ maxWidth: '120px' }}
                                                        onClick={() => {

                                                            push({ num: props.values.propList.length, TaskVariable: "", ID: 0, IsDelete: false });
                                                        }
                                                        } >
                                                        Add
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )}

                                    </FieldArray>
                                } 
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog></MuiThemeProvider>
        </div>
    );
}